import { api } from "@/api/axios.ts";
import { ApiRuleRegistryResponse, ApplyToEmployees, ApplyToRequest } from "@/types/rule.types.ts";

export const apiRule = {
  calcApplyTo: async function (payload: ApplyToRequest, signal?: AbortSignal) {
    return api.post<ApplyToEmployees>("/api/v1/rules/apply-to", payload, signal);
  },
  getRegistry: async function () {
    return api.get<ApiRuleRegistryResponse>("/api/v1/rules/registry");
  },
};
